var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Amap"},[_c('div',{attrs:{"id":"container"}}),_c('div',{attrs:{"id":"tip"}},[_c('input',{ref:"keyword",attrs:{"type":"text","id":"keyword","name":"keyword","value":"","placeholder":"请输入客户位置，选中提示搜索"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }